module.exports = __webpack_public_path__ + "static/media/makeup.9db1a9ec.png";